import { css } from "@emotion/react"
import { ExpandableDescription } from "./ExpandableDescription"

export default function PodcastHeader({
  title,
  description,
}: {
  title: string
  description?: string
}) {
  const hasDescription = !!description

  return (
    <div css={styles.wrapper}>
      <h2 css={styles.heading}>{title}</h2>
      {hasDescription && <ExpandableDescription text={description} isHtml />}
    </div>
  )
}

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  `,
  heading: css`
    font-size: 30px;
  `,
}
